import React from 'react';
import LatestTransactionIdContainer from '../containers/latest_transaction_id_container';

const LatestTransactionIdContext = React.createContext(new LatestTransactionIdContainer());

export default LatestTransactionIdContext;
